import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function Services() {
  const { ref: sectionRef, isVisible } = useScrollReveal();

  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential Insulation',
      description: 'Complete home insulation solutions including attics, walls, crawl spaces, and garages. Improve comfort and reduce energy bills.',
      link: '/residential-insulation-yuma'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Insulation',
      description: 'Professional insulation services for commercial buildings, warehouses, and industrial facilities. Meet energy codes and regulations.',
      link: '/commercial-insulation-yuma'
    },
    {
      icon: 'ri-drop-line',
      title: 'Closed-Cell Spray Foam',
      description: 'High-density foam with superior R-value and moisture barrier properties. Ideal for exterior walls and moisture-prone areas.',
      link: '/closed-cell-spray-foam'
    },
    {
      icon: 'ri-bubble-chart-line',
      title: 'Open-Cell Spray Foam',
      description: 'Cost-effective solution with excellent sound dampening. Perfect for interior walls and attic spaces.',
      link: '/open-cell-spray-foam'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Attic Insulation',
      description: 'Specialized attic insulation to prevent heat loss and gain. Reduce cooling costs by up to 40% in Arizona\'s extreme climate.',
      link: '/insulation-services-arizona'
    },
    {
      icon: 'ri-tools-line',
      title: 'Insulation Removal',
      description: 'Safe removal of old, damaged, or contaminated insulation. Prepare your space for new, efficient insulation installation.',
      link: '/insulation-services-arizona'
    }
  ];

  return (
    <section ref={sectionRef} id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our Insulation Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive spray foam insulation solutions for residential and commercial properties in Yuma, Arizona
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className={`group bg-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer border border-gray-100 hover:border-blue-200 hover:-translate-y-2 scroll-reveal ${isVisible ? 'revealed' : ''}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {service.description}
              </p>
              <div className="flex items-center text-blue-900 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                <span>Learn More</span>
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform duration-300"></i>
              </div>
            </a>
          ))}
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {services.map((service, index) => (
              <a
                key={index}
                href={service.link}
                className={`group bg-white rounded-xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer border border-gray-100 hover:border-blue-200 scroll-reveal ${isVisible ? 'revealed' : ''}`}
                style={{ width: '280px', transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-3 text-sm">
                  {service.description}
                </p>
                <div className="flex items-center text-blue-900 font-semibold gap-2 text-sm">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
              </a>
            ))}
          </div>
          <div className="text-center mt-4 text-sm text-gray-500">
            <i className="ri-arrow-left-right-line mr-1"></i>
            Swipe to see more
          </div>
        </div>
      </div>
    </section>
  );
}